// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-item[data-v-75cbc63e]{font-size:25px;cursor:pointer;text-align:center;color:#187cc6}", ""]);
// Exports
module.exports = exports;
